import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import FeaturedServicesStyles from '../styles/FeaturedServices.module.sass'

/**
 * Display a section with Featured Services
 */
const FeaturedServices = () => {
  const data = useStaticQuery(posts)

  return (
    <div
      className={`container has-text-left ${FeaturedServicesStyles.featuredServices}`}
    >
      <div className={`columns is-multiline ${FeaturedServicesStyles.columns}`}>
        {data.allMdx.edges.map(edge => {
          return (
            <div
              key={edge.node.id}
              className={`column is-half-tablet ${FeaturedServicesStyles.column}`}
            >
              <Link to='/contact/' className="has-text-grey">
                <header className={FeaturedServicesStyles.header}>
                  {edge.node.fields.image ? (
                    <Img fluid={edge.node.fields.image.childImageSharp.fluid} alt={edge.node.frontmatter.title} />
                  ) : null}
                  <span className={`title ${FeaturedServicesStyles.title}`}>
                    {edge.node.frontmatter.shortenedTitle ||
                      edge.node.frontmatter.title}
                  </span>
                  <span className={FeaturedServicesStyles.price}>
                    from <strong>&euro;{edge.node.frontmatter.price}/m<sup>2</sup></strong>
                  </span>
                </header>
                <div className={FeaturedServicesStyles.description}>
                  {edge.node.frontmatter.description}
                </div>
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FeaturedServices

export const posts = graphql`
  {
    allMdx(
      filter: {
        fields: { featuredPosition: { gt: 0 } }
      }
      sort: { fields: fields___featuredPosition }
      limit: 4
    ) {
      edges {
        node {
          id
          fields {
            slug
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          frontmatter {
            description
            title
            price
          }
        }
      }
    }
  }
`
